'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UP = exports.UP = 'UP';
var DOWN = exports.DOWN = 'DOWN';
var HEADER_HEIGHT = exports.HEADER_HEIGHT = 56;
var PAGE_TITLE_HEIGHT = exports.PAGE_TITLE_HEIGHT = 56;
var HEIGHT_TO_ALLOW_SCROLL = exports.HEIGHT_TO_ALLOW_SCROLL = HEADER_HEIGHT + PAGE_TITLE_HEIGHT;